import { SERVER_API } from "../../Constant";
import axios from "axios";

export const AddPayments = async (data: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(data));
    const response = await axios.post(
      `${SERVER_API}/Payments/add_payment_data.php`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Add payments failed:", error);
    return { error: "Add payments failed" };
  }
};
